export const state = () => {
	return {
		campaign_templates: [],
		ttl_campaign_templates: null,
		cache_duration_campaign_templates: 10800000, // 3 heures
		cache_key_campaign_templates: '',
		campaign_template: {},
		ttl_campaign_template: null,
		cache_duration_campaign_template: 10800000, // 3 heures
		cache_key_campaign_template: '',
	}
}

function isInCacheCampaignTemplates(state) {
	if (state.cache_key_campaign_templates !== buildCacheKeyCampaignTemplates()) {
		return false
	}
	if (state.ttl_campaign_templates === null || state.ttl_campaign_templates < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyCampaignTemplates() {
	return 'campaign_templates'
}

function isInCacheCampaignTemplate(state, templateId) {
	if (state.cache_key_campaign_template !== buildCacheKeyCampaignTemplate(templateId)) {
		return false
	}
	if (state.ttl_campaign_template === null || state.ttl_campaign_template < Date.now()) {
		return false
	}
	return true
}

function buildCacheKeyCampaignTemplate(templateId) {
	return `campaign_template:${templateId}`
}

export const actions = {
	async list({ state, commit }, { companyId }) {
		if (isInCacheCampaignTemplates(state)) {
			return state.campaign_templates
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/campaign-templates/`)
			.then((res) => {
				commit('setCampaignTemplates', res)
				return res
			})
			.catch((err) => {
				commit('clearCacheCampaignTemplates')
				throw err
			})
	},

	async retrieve({ state, commit }, { companyId, templateId }) {
		if (isInCacheCampaignTemplate(state, templateId)) {
			return state.campaign_template
		}
		return await useNuxtApp()
			.$api(`api/company/${companyId}/campaign-templates/${templateId}/`)
			.then((res) => {
				commit('setCampaignTemplate', { data: res, templateId })
				return res
			})
			.catch((err) => {
				commit('clearCacheCampaignTemplate')
				throw err
			})
	},
}

export const mutations = {
	setCampaignTemplates(state, data) {
		state.campaign_templates = data
		state.ttl_campaign_templates = Date.now() + state.cache_duration_campaign_templates
		state.cache_key_campaign_templates = buildCacheKeyCampaignTemplates()
	},

	clearCacheCampaignTemplates(state) {
		state.campaign_templates = []
		state.ttl_campaign_templates = null
		state.cache_key_campaign_templates = ''
	},

	setCampaignTemplate(state, { data, templateId }) {
		state.campaign_template = data
		state.ttl_campaign_template = Date.now() + state.cache_duration_campaign_template
		state.cache_key_campaign_template = buildCacheKeyCampaignTemplate(templateId)
	},

	clearCacheCampaignTemplate(state) {
		state.campaign_template = []
		state.ttl_campaign_template = null
		state.cache_key_campaign_template = ''
	},
}
